import React, { useState } from 'react';

import { getArrFromLocalStorage, setArrToLocalStorage } from '@vlabs/monokit/shared/lib/localStorage';
import { DeleteIcon } from '@vlabs/icons';
import { Control, openConfirmPopup } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { deleteNotification } from '../store';
import st from './SharedCell.module.sass';

export function DeleteNotificationCellComponent({ value = {}, deletion }) {
  const { t } = useTranslation();

  const [vaNotificationsArr, setVANotificationsArr] = useState(getArrFromLocalStorage('VANotificationsArr'));

  const { name, type, uuid, reset } = value;
  const message = (<span>{t('vlNotifier:подтверждение.удаление.полный текст', { name })}</span>);

  const onDeleteNotification = () => {
    const onConfirm = async () => {
      if (type === 'events') await deletion(uuid);
      if (type === 'videoanalytics') {
        const newArr = vaNotificationsArr?.filter((va) => va.uuid !== uuid);
        setArrToLocalStorage('VANotificationsArr', newArr);
        toast.success(t('vlNotifier:удаление.успех'));
        reset();
      }
    };
    openConfirmPopup({
      title: t('vlNotifier:подтверждение.удаление.заголовок'),
      message,
      type: 'delete',
      onConfirm,
    }, { className: st.Popup });
  };

  return (
    <Control.IconButton
      data-testid="notificationDeleteButton"
      icon={<DeleteIcon />}
      kind="negative"
      onClick={onDeleteNotification}
      variant="flat"
    />
  );
}

export const DeleteNotificationCell = connect(
  null,
  (dispatch) => ({
    deletion: (id) => dispatch(deleteNotification(id)),
  }),
)(DeleteNotificationCellComponent);

DeleteNotificationCell.propTypes = {
  value: PropTypes.object,
  deletion: PropTypes.func,
};
